/**
 * Temporary store for the profile draft.
 *
 * Why: registering with an email address that already made a guest purchase gets the
 * submitted profile discarded server-side. Rather than making the shopper type it all
 * again after activating the account, keep what they submitted in the browser and offer
 * it back on the profile form.
 *
 * This never alters what is sent to the app. It is only a copy held in the browser.
 *
 * Notes:
 *  - The password is never stored.
 *  - base64 is obfuscation, not protection. It does not stop anyone determined; it keeps
 *    a name, address and birthday from sitting in plain text where they can be read
 *    incidentally.
 *  - localStorage can throw (private mode, blocked site data). Wrap every access.
 */
(function () {
  'use strict';

  /** Storage key. Prefixed with the store, not a vendor. */
  var KEY = 'unico_pf';

  /**
   * Retention window. The default lives in the theme setting (会員登録 > 入力内容の保持時間)
   * and nowhere else; layout/theme.liquid passes it in via window.UNICO_PF_TTL_HOURS.
   * If it never arrives, TTL_MS is NaN, load() discards the record, and the prefill
   * quietly turns off — the redirect itself is unaffected.
   */
  var TTL_MS = Number(window.UNICO_PF_TTL_HOURS) * 60 * 60 * 1000;

  /** btoa fails on non-ASCII and this content is largely Japanese, so go through bytes. */
  function pack(obj) {
    var bytes = new TextEncoder().encode(JSON.stringify(obj));
    var bin = '';
    for (var i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
    return btoa(bin);
  }

  function unpack(str) {
    var bin = atob(str);
    var bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return JSON.parse(new TextDecoder().decode(bytes));
  }

  /** Stored as an expiry, not a creation time, so the reader need not know the policy. */
  function save(data) {
    try {
      var record = Object.assign({ exp: Date.now() + TTL_MS }, data);
      localStorage.setItem(KEY, pack(record));
    } catch (e) {
      /* Failing to store must not interrupt registration */
    }
  }

  /**
   * Read, and sweep at the same time: expired or unreadable records are removed here.
   * The layout calls this on every page, so nothing lingers on visits that never reach
   * the restore path.
   */
  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var record = unpack(raw);
      if (!record.exp || Date.now() > record.exp) {
        clear();
        return null;
      }
      return record;
    } catch (e) {
      clear();
      return null;
    }
  }

  function clear() {
    try {
      localStorage.removeItem(KEY);
    } catch (e) {
      /* noop */
    }
  }

  window.UnicoProfileDraft = { save: save, load: load, clear: clear, KEY: KEY, TTL_MS: TTL_MS };

  /* Sweep on load: same code as the read. Anything past its window goes now. */
  load();
})();
